import React, { useState, useEffect } from "react";
import { Container, Box } from "@material-ui/core";
import { useIntl, FormattedMessage } from "react-intl";

import { useQuery } from "../../common/Hooks";
import { PageTitle } from "../../components/page-title/PageTitle";
import { useStyles } from "./BusinessSearchScreen.style";
import { SignupLayout } from "../../common/SignupLayout";
import { BusinessSearchInput } from "./components/BusinessSearchInput";
import { LoadingStateAAttributes } from "../../attributes/base-attributes";
import { BusinessSearchResult } from "./components/BusinessSearchResult";
import BusinessService from "../../services/BusinessService";
import Business from "../../models/Business";
import BusinessBranchService from "../../services/BusinessBranchService";
import BusinessBranch from "../../models/BusinessBranch";
import { SlideWrapper } from "../../components/slide-wrapper/SlideWrapper";

export const BusinessSearchScreen = (props: any) => {
  const classes = useStyles(props);
  const queryParams = useQuery(); // default = null | bo
  const intl = useIntl();
  // State
  const [query, setQuery] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(
    (): LoadingStateAAttributes => LoadingStateAAttributes.initial
  );

  function handleQueryChange(value) {
    setQuery(value);
  }

  function searchBusinessBranch(query: string) {
    const response = BusinessBranchService.searchByName(query);

    response.then((response) => {
      let results: Array<BusinessBranch> = [];

      if (response.isSuccess && response.data.code === 100) {
        JSON.parse(JSON.stringify(response.data.data)).forEach(
          (item, index) => {
            results.push(BusinessBranch.fromJson(item));
          }
        );
        setData(results);
        setLoading(LoadingStateAAttributes.success);
      } else {
        setData(null);
        setLoading(LoadingStateAAttributes.failure);
      }
    });
  }

  function searchBusiness(query: string) {
    const response = BusinessService.searchByName(query);

    response.then((response) => {
      let results: Array<Business> = [];

      if (response.isSuccess && response.data.code === 100) {
        JSON.parse(JSON.stringify(response.data.data)).forEach(
          (item, index) => {
            results.push(Business.fromJson(item));
          }
        );
        setData(results);
        setLoading(LoadingStateAAttributes.success);
      } else {
        setData(null);
        setLoading(LoadingStateAAttributes.failure);
      }
    });
  }

  function handleRequest() {
    if (query.length === 0) {
      setData(null);
      setLoading(LoadingStateAAttributes.initial);
    } else if (query.length >= 3) {
      if (queryParams.get("option") === "bo") {
        searchBusiness(query);
      } else {
        searchBusinessBranch(query);
      }
    }
  }

  useEffect(() => {
    handleRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <>
      <PageTitle
        title={intl.formatMessage({ id: "sharedScreen.businessSearch" })}
      />
      <SignupLayout mode="light" withMenu>
        <Container maxWidth="xs" className={classes.root}>
          <SlideWrapper>
            <Box maxWidth="xs" className={classes.slideInner}>
              <Box component="h3">
                {queryParams.get("option") === "bo" ? (
                  <FormattedMessage id="sharedScreen.whatBusinessName" />
                ) : (
                  <FormattedMessage id="sharedScreen.whatBranchName" />
                )}
              </Box>
              <Box mt={4}>
                <BusinessSearchInput
                  fullWidth
                  placeholder={
                    queryParams.get("option") === "bo"
                      ? intl.formatMessage({
                          id: "sharedScreen.tapBusinessName",
                        })
                      : intl.formatMessage({
                          id: "sharedScreen.tapBranchName",
                        })
                  }
                  onChange={(event) => handleQueryChange(event.target.value)}
                />
              </Box>

              {loading === LoadingStateAAttributes.failure ? (
                <Box mt={2} component="span" className={classes.error}>
                  <FormattedMessage id="sharedScreen.unknownError" />
                </Box>
              ) : (
                <Box mt={4}>
                  <BusinessSearchResult
                    data={data}
                    query={query}
                    flag={queryParams.get("option")}
                  />
                </Box>
              )}
            </Box>
          </SlideWrapper>
        </Container>
      </SignupLayout>
    </>
  );
};

BusinessSearchScreen.routeName = "/business-search";
